// packages

// components

import Topbar from '../Topbar/TopbarLP';
import Content from '../Content/Content';
import Footer from '../Footer/FooterLP';

// api

// styles
import './Main.scss';

const Main = (props) => {
  return (
    <div className='main'>
      <div className='main__body'>
        <Topbar />
        <Content>{props.children}</Content>
        <Footer />
      </div>
    </div>
  );
};

export default Main;
